import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { PowChallengeResponse } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function pow(config) {
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(PowChallengeResponse)),
    });
    return Object.freeze({
        /**
         * Get a proof-of-work challenge.
         *
         * Returns a challenge that must be solved before submitting requests to email-sending endpoints. The client must find an integer `solution` such that: `SHA-256(nonce + ":" + str(solution))` has at least `difficulty` leading zero bits.
         *
         * @returns A challenge with nonce and difficulty.
         */
        get: async () => {
            const result = await requestParams(config, 'GET', `/api/v1/pow/challenge`, getResponse.v, undefined);
            return result;
        },
    });
}
